<p>logged-in works!</p>
